import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Table,
  Container,
  ListGroup,
  Card,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import WhatsAppAPI from "../api/WhatsAppAPI";
import Badge from "react-bootstrap/Badge";
import moment from "moment";
import moments from "moment-timezone";

import { DateRangePicker } from "react-date-range";

const Billing = ({ selectedWhatsAppSetting }) => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
  const [billBody, setBillBody] = useState([]);
  const predefinedPaidLabels = [
    "MARKETING",
    "UTILITY",
    "AUTHENTICATION",
    "SERVICE",
  ];
  const predefinedFreeLabels = ["FREE_TIER", "FREE_ENTRY_POINT"];

  const [dateRange, setDateRange] = useState([
    {
      startDate: moment().startOf("month").toDate(),
      endDate: moment().endOf("month").toDate(),
      key: "selection",
    },
  ]);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);

  // useEffect(() => {
  //   setDateRange([
  //     {
  //       startDate: moment().startOf('month').format(),
  //       endDate: moment().endOf('month').format(),
  //       key: 'selection'
  //     }
  //   ]);
  //   let firstdate = moments().tz("Asia/Kolkata").startOf('month').unix();
  //   let lastdate = moments().tz("Asia/Kolkata").endOf('month').unix();
  //   init(firstdate, lastdate);
  //   setIsSpinner(false);
  // }, [selectedWhatsAppSetting]);

  // async function init(start='', end='') {
  //   const billData = await WhatsAppAPI.getBillingCostsBySetting(selectedWhatsAppSetting, start, end);
  //   // console.log(billData);
  //   if (billData.success) {
  //     setBody(billData);
  //     let body = fetchTableData(billData.result);
  //     setBillBody(body);
  //   } else {
  //     setBody([]);
  //     setBillBody(null);
  //     toast.error(billData.error);
  //   }
  //   setIsSpinner(true);
  // }

  useEffect(() => {
    setDateRange([
      {
        startDate: moment().startOf("month").format(),
        endDate: moment().endOf("month").format(),
        key: "selection",
      },
    ]);

    let firstdate = moment().tz("Asia/Kolkata").startOf("month").unix();
    let lastdate = moment().tz("Asia/Kolkata").endOf("month").unix();

    if (selectedWhatsAppSetting) {
      init(firstdate, lastdate);
      setIsSpinner(false);
    } else {
      setBody([]);
      setBillBody(null);
      setIsSpinner(true);
    }
  }, [selectedWhatsAppSetting]);

  async function init(start = "", end = "") {
    // if (!selectedWhatsAppSetting) return; // Prevent API call if the value is empty

    const billData = await WhatsAppAPI.getBillingCostsBySetting(
      selectedWhatsAppSetting,
      start,
      end
    );
    // console.log("billData",billData)
    if (billData.success) {
      setBody(billData);
      let body = fetchTableData(billData.result);
      setBillBody(body);
    } else {
      setBody([]);
      setBillBody(null);
      toast.error(billData.error);
    }
    setIsSpinner(true);
  }

  const fetchTableData = (data) => {
    // All messages (for now, just use total volume as sent/delivered, since your data doesn't distinguish)
    let messagesSent = 0,
      messagesDelivered = 0;

    // All deliveries
    const allDeliveries = {
      Marketing: 0,
      Utility: 0,
      Authentication: 0,
      Service: 0,
    };

    // Free deliveries
    const freeDeliveries = {
      "Free customer service": 0,
      "Free entry point": 0,
    };

    // Paid deliveries
    const paidDeliveries = {
      Marketing: 0,
      Utility: 0,
      Authentication: 0,
    };

    // Approximate charges
    const charges = {
      Marketing: 0,
      Utility: 0,
      Authentication: 0,
    };

    data.forEach((item) => {
      // All messages (sent/delivered are not distinguished in your data, so use volume for both)
      messagesSent += item.volume;
      messagesDelivered += item.volume;
      // messagesReceived: set to 0 unless you have this info

      // All deliveries
      if (item.pricing_category === "MARKETING_LITE")
        allDeliveries.Marketing += item.volume;
      if (item.pricing_category === "UTILITY")
        allDeliveries.Utility += item.volume;
      if (item.pricing_category === "AUTHENTICATION")
        allDeliveries.Authentication += item.volume;
      if (item.pricing_category === "SERVICE")
        allDeliveries.Service += item.volume;

      // Free deliveries
      if (item.pricing_type === "FREE_CUSTOMER_SERVICE")
        freeDeliveries["Free customer service"] += item.volume;
      if (item.pricing_type === "FREE_ENTRY_POINT")
        freeDeliveries["Free entry point"] += item.volume;

      // Paid deliveries
      if (item.pricing_type === "REGULAR") {
        if (item.pricing_category === "MARKETING_LITE")
          paidDeliveries.Marketing += item.volume;
        if (item.pricing_category === "UTILITY")
          paidDeliveries.Utility += item.volume;
        if (item.pricing_category === "AUTHENTICATION")
          paidDeliveries.Authentication += item.volume;
      }

      // Approximate charges
      if (item.pricing_type === "REGULAR") {
        if (item.pricing_category === "MARKETING_LITE")
          charges.Marketing += item.cost;
        if (item.pricing_category === "UTILITY") charges.Utility += item.cost;
        if (item.pricing_category === "AUTHENTICATION")
          charges.Authentication += item.cost;
      }
    });

    return [
      {
        title: "All deliveries",
        value: Object.values(allDeliveries).reduce((a, b) => a + b, 0),
        badgeBg: "primary",
        items: Object.entries(allDeliveries).map(([label, value]) => ({
          label,
          value,
        })),
      },
      {
        title: "Free deliveries",
        value: Object.values(freeDeliveries).reduce((a, b) => a + b, 0),
        badgeBg: "danger",
        items: Object.entries(freeDeliveries).map(([label, value]) => ({
          label,
          value,
        })),
      },
      {
        title: "All messages",
        value: messagesSent + messagesDelivered,
        badgeBg: "primary",
        items: [
          { label: "Messages sent", value: messagesSent },
          { label: "Messages delivered", value: messagesDelivered },
        ],
      },
      {
        title: "Paid deliveries",
        value: Object.values(paidDeliveries).reduce((a, b) => a + b, 0),
        badgeBg: "info",
        items: Object.entries(paidDeliveries).map(([label, value]) => ({
          label,
          value,
        })),
      },
      {
        title: "Approximate charges",
        value: ` ${Object.values(charges)
          .reduce((a, b) => a + b, 0)
          .toFixed(2)}`,
        badgeBg: "success",
        items: Object.entries(charges).map(([label, value]) => ({
          label,
          value: ` ${value.toFixed(2)}`,
        })),
      },
    ];
  };

  const HelpTooltip = ({ helpText }) => (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Popover id={`popover-positioned-auto`}>
          <Popover.Body>{helpText}</Popover.Body>
        </Popover>
      }
    >
      <i
        className="fa-solid fa-circle-info text-secondary"
        style={{ cursor: "pointer" }}
      ></i>
    </OverlayTrigger>
  );

  const handleSelect = (ranges) => {
    setDateRange([ranges.selection]);
  };

  const selectDate = () => {
    setShowCalendar(false);
    let firstdate = moments(dateRange[0].startDate)
      .tz("Asia/Kolkata")
      .startOf("day")
      .unix();
    let lastdate = moments(dateRange[0].endDate)
      .tz("Asia/Kolkata")
      .endOf("day")
      .unix();
    init(firstdate, lastdate);
  };

  const closeCalendar = () => {
    setShowCalendar(false);
  };

  return (
    <>
      <Container className="mt-5">
        <Row className="g-0 mx-5 text-center ">
          <Col lg={12} xs={12} sm={12}>
            <div
              className=" text-center p-2"
              style={{
                height: "40px",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
            >
              <span
                className="fw-semibold p-1"
                style={{ color: "#605C68", fontSize: "large" }}
              >
                Billing
              </span>
            </div>
          </Col>
        </Row>
      </Container>
      {isSpinner ? (
        <>
          <Container className="mt-5 mb-5">
            <Row
              className="g-4 mx-5"
              style={{
                backgroundColor: "#eeeff0",
                padding: "5px 20px 20px",
                borderRadius: "8px",
              }}
            >
              <Col lg={12} xs={12} sm={12}>
                <div className="relative">
                  <Form.Group className="d-flex align-items-center">
                    <Form.Control
                      type="text"
                      readOnly
                      className="border p-2 cursor-pointer form-control"
                      value={`${moment(dateRange[0].startDate).format(
                        "DD/MM/YYYY"
                      )} - ${moment(dateRange[0].endDate).format(
                        "DD/MM/YYYY"
                      )}`}
                      onClick={() => setShowCalendar(!showCalendar)}
                    />
                  </Form.Group>

                  {showCalendar && (
                    <div
                      ref={calendarRef}
                      className="mt-2 d-flex"
                      style={{ position: "absolute", zIndex: "1000" }}
                    >
                      <Card bg="light">
                        <Card.Body>
                          <DateRangePicker
                            showSelectionPreview={true}
                            ranges={dateRange}
                            onChange={handleSelect}
                            direction="horizontal"
                            months={2}
                            moveRangeOnFirstSelection={false}
                            maxDate={new Date()}
                            minDate={
                              new Date(
                                new Date().setDate(new Date().getDate() - 88)
                              )
                            }
                          />
                        </Card.Body>
                        <Card.Footer className="text-end">
                          <Button className="me-2" onClick={closeCalendar}>
                            Close
                          </Button>
                          <Button onClick={selectDate}>Select Date</Button>
                        </Card.Footer>
                      </Card>
                    </div>
                  )}
                </div>
              </Col>
              {billBody ? (
                billBody.map((card, index) => (
                  <Col key={index} md={index < 3 ? 4 : 6}>
                    <Card
                      className="h-100 border-0 shadow-sm"
                      style={{
                        borderRadius: "8px !important",
                        border: "1px solid #dee2e6 !important",
                      }}
                    >
                      <Card.Header
                        className="d-flex justify-content-between align-items-center bg-light"
                        style={{ fontSize: "1.24rem" }}
                      >
                        <span className="fw-bold text-secondary">
                          {card.title}{" "}
                          {card?.helpText ? (
                            <HelpTooltip helpText={card.helpText} />
                          ) : (
                            ""
                          )}
                        </span>
                        <Badge bg={card.badgeBg} pill>
                          {card.value}
                        </Badge>
                      </Card.Header>
                      <ListGroup variant="flush">
                        {card.items.map((item, idx) => (
                          <ListGroup.Item
                            key={idx}
                            className="d-flex justify-content-between align-items-center"
                            style={{ fontSize: "0.9rem" }}
                          >
                            <span>{item.label}</span>
                            <span className="fw-bold">{item.value}</span>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Card>
                  </Col>
                ))
              ) : (
                <div className="text-center fs-5">No Billing Data Found</div>
              )}
            </Row>
          </Container>
          <ToastContainer />
        </>
      ) : (
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      )}
    </>
  );
};
export default Billing;
